import {DEFAULT_SEARCH_KEY} from "@/lib/hooks/useDebouncedSearch.ts";

const LEGACY_ID_KEY = "pop";

/** Rewrites the legacy `?pop=<id>` Tags link into a search. Returns undefined when there is nothing to rewrite. */
export const normalizeLegacyTagsListParams = (params: URLSearchParams): URLSearchParams | undefined => {
  if (!params.has(LEGACY_ID_KEY)) {
    return undefined;
  }
  const normalized = new URLSearchParams(params);
  normalized.delete(LEGACY_ID_KEY);
  const legacyId = params.get(LEGACY_ID_KEY);
  if (legacyId && !params.get(DEFAULT_SEARCH_KEY)) {
    normalized.set(DEFAULT_SEARCH_KEY, legacyId);
  }
  return normalized;
};
